import style from './StorePage.module.scss';

export function StorePage() {
    return (
        <div className={style.root}>
            <h1>Store</h1>
        </div>
    );
}
